/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectPortfolioReportTitleBar_viewer = {
    readonly email: string | null;
    readonly actualPersonId: string | null;
    readonly " $refType": "ProjectPortfolioReportTitleBar_viewer";
};
export type ProjectPortfolioReportTitleBar_viewer$data = ProjectPortfolioReportTitleBar_viewer;
export type ProjectPortfolioReportTitleBar_viewer$key = {
    readonly " $data"?: ProjectPortfolioReportTitleBar_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectPortfolioReportTitleBar_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPortfolioReportTitleBar_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '9451cf005dc5e6c5763601e15212603c';
export default node;
